import { useEffect, useState } from "react";
import { getLastDataSource, type DataSource } from "@/lib/dataGateway";

/**
 * Badge discreto (apenas em DEV) que mostra a última fonte de dados usada pelo
 * DataGateway: 'local' (servidor da loja) ou 'cloud' (Supabase). Ajuda a depurar a
 * Fase 2. Não é renderizado em produção.
 */
export function DataSourceIndicator() {
  const [source, setSource] = useState<DataSource | null>(getLastDataSource());

  useEffect(() => {
    const handler = (e: Event) => setSource((e as CustomEvent<DataSource>).detail);
    window.addEventListener("datagateway-source", handler);
    return () => window.removeEventListener("datagateway-source", handler);
  }, []);

  if (!import.meta.env.DEV || !source) return null;

  const isLocal = source === "local";
  return (
    <div
      title="Fonte de dados atual (DataGateway) — visível só em dev"
      style={{
        position: "fixed",
        bottom: 8,
        right: 8,
        zIndex: 99999,
        padding: "2px 8px",
        borderRadius: 9999,
        fontSize: 11,
        fontFamily: "monospace",
        fontWeight: 600,
        color: "#fff",
        background: isLocal ? "#16a34a" : "#2563eb",
        boxShadow: "0 1px 3px rgba(0,0,0,.3)",
        pointerEvents: "none",
        opacity: 0.85,
      }}
    >
      {isLocal ? "● local" : "● nuvem"}
    </div>
  );
}
